import { Injector } from "@angular/core";
import { ControlContainer, ControlValueAccessor } from "@angular/forms";

/** @deprecated Please use `FormControlComponent` from `@intocare/angular-forms` instead. */
export abstract class CustomControlValueAccessor<OutputType = unknown> implements ControlValueAccessor {
	/** The registered callback function called when a change or input event occurs on the input element. */
	protected onChange = (_: OutputType) => {}; // eslint-disable-line no-empty,@typescript-eslint/no-empty-function

	/** The registered callback function called when a blur event occurs on the input element. */
	protected onTouched = () => {}; // eslint-disable-line no-empty,@typescript-eslint/no-empty-function

	constructor(injector: Injector) {
		// Use a timeout to wait for everything to be initialized.
		setTimeout(() => {
			// Get the control in the outer form of where this ControlValueAccessor is used.
			const control = injector.get(ControlContainer) as any;

			// Check if the control is found and the control has a form
			if (control && control.form) {
				// Keep a reference to the original `markAsTouched` handler.
				const markAsTouched = control.form.markAsTouched.bind(control.form);

				// Override the `markAsTouched` handler with our own.
				control.form.markAsTouched = () => {
					// Invoke the original `markAsTouchedHandler`.
					markAsTouched();

					// Invoke the (optional) custom `markAsTouchedHandler`.
					this.markAsTouched();
				};

				// Keep a reference to the original `markAsPristine` handler.
				const markAsPristine = control.form.markAsPristine.bind(control.form);

				// Override the `markAsPristine` handler with our own.
				control.form.markAsPristine = () => {
					// Invoke the original `markAsPristineHandler`.
					markAsPristine();

					// Invoke the (optional) custom `markAsPristineHandler`.
					this.markAsPristine();
				};
			}
		});
	}

	/**
	 * Sets the `value` property on the input element.
	 *
	 * @param value - The checked value.
	 */
	abstract writeValue(value: any): void;

	/**
	 * Registers a function called when the control value changes.
	 *
	 * @param fn - The callback function.
	 */
	registerOnChange(fn: (_: OutputType) => void) {
		this.onChange = fn;
	}

	/**
	 * Registers a function called when the control is touched.
	 *
	 * @param fn - The callback function.
	 */
	registerOnTouched(fn: () => void) {
		this.onTouched = fn;
	}

	/** Callback which fires when the control has been marked as touched. */
	markAsTouched() {} // eslint-disable-line no-empty,@typescript-eslint/no-empty-function

	/** Callback which fires when the control has been marked as pristine. */
	markAsPristine() {} // eslint-disable-line no-empty, @typescript-eslint/no-empty-function
}
